import { createSupabase } from '@parleyride/supabase';
import { demoAwareFetch } from '@/lib/demo/fetch-shim';
import { installDemoRealtime } from '@/lib/demo/realtime-shim';
import { installDemoStorage } from '@/lib/demo/storage-shim';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error('Missing Supabase environment variables. Check your .env file.');
}

export const supabase = createSupabase({
  url: SUPABASE_URL,
  anonKey: SUPABASE_PUBLISHABLE_KEY,
  storage: localStorage,
  detectSessionInUrl: true,
  // The demo seam. A no-op — a straight passthrough to the real fetch — unless
  // a demo session exists in this tab. See lib/demo/fetch-shim.ts.
  fetch: demoAwareFetch,
});

// The realtime seam. Websockets bypass `global.fetch`, so `.channel()` needs
// its own interception — and patching the instance reaches the three call
// sites in packages/hooks that a web-only guard could not.
installDemoRealtime(supabase);

// The third seam. Storage has its own client that does not go through
// `global.fetch` in a form the PostgREST parser understands, and five call
// sites upload avatars, vehicle photos and driver documents.
installDemoStorage(supabase);
